import { useCurrentUser } from '../HOC/CurrentUserContextProvider';

export const useUserOrg = () => {
  const { user } = useCurrentUser();
  return user?.orgId as string;
};
